// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__Nma9t","Centered":"styles_Centered__3Vscr","H1":"styles_H1__12oL_","H2":"styles_H2__3qqeU","Button":"styles_Button__JuWBi"};